module.exports = __webpack_public_path__ + "img/card.ad821fee.svg";